import React from "react";

import { templates } from "@reactivated";

import { DistanceToStoreSSR } from "../apps/retail-locator/DistanceToStoreSSR";

export const Template = (
    props: templates.DistanceToStoreTemplate,
): React.JSX.Element => {
    return <DistanceToStoreSSR {...props} />;
};
